import React from "react";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(theme => ({
  pageLayout: {
    display: "grid",
    gridTemplateColumns: "250px 1fr 250px",
    gridGap: "16px",
    minHeight: "500px",
    "@media(max-width: 1024px)": {
      gridTemplateColumns: "200px 1fr",
      gridGap: "8px"
    },
    "@media(max-width: 768px)": {
      gridTemplateColumns: "1fr",
      padding: "0 16px"
    }
  }
}));

const PageLayout = ({ children }) => {
  const classes = useStyles();
  return <div className={classes.pageLayout}>{children}</div>;
};

export default PageLayout;
